(function($, FUNCTIONS, cssua){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const slideSpeed = '400';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		cmmodal() {
			var scrollTopNow;

			// youtube
			$('.cm-modal-btn_youtube').on('click', function(event){
				var id = $(this).data('id');

				if(!$(this).data('list')) {
					$('.cm-modal-overlay_youtube .cm-modal-inner .mod-youtube iframe').attr('src', '//www.youtube.com/embed/' + id + '?rel=0;&iv_load_policy=3');
				}else {
					$('.cm-modal-overlay_youtube .cm-modal-inner .mod-youtube iframe').attr('src', '//www.youtube.com/embed/' + id + '?list=' + $(this).data('list') + '&rel=0;&iv_load_policy=3');
				}
				
				$('.cm-modal-overlay_youtube').addClass(a);
				scrollTopNow = $(window).scrollTop();
				$('body').addClass(f);
				$( '.container' ).css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				event.preventDefault();
			});

			// liveact
			$('.cm-modal-btn_liveact').on('click', function(event){
				var directory = $(this).data('directory');
				var embed = $(this).data('embed');
				
				$('.cm-modal-overlay_liveact .cm-modal-inner .mod-youtube iframe').attr('src', 'https://aderans.contents.liveact.cri-mw.jp/' + directory + '/' + embed + '.html?loop=true&content-type=thumbnail&playable-buffer=70%25&play-trigger=scroll');
				
				$('.cm-modal-overlay_liveact').addClass(a);
				scrollTopNow = $(window).scrollTop();
				$('body').addClass(f);
				$( '.container' ).css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				event.preventDefault();
			});

			// liveact360
			$('.cm-modal-btn_liveact360').on('click', function(event){
				var directory = $(this).data('directory');
				var embed = $(this).data('embed');

				$('.cm-modal-overlay_liveact360 .cm-modal-inner .mod-youtube iframe').attr('src', 'https://aderans.contents.liveact-vault.com/' + directory + '/' + embed + '.html?loop=true&content-type=rotate360&playable-buffer=70%25&swipe-direction=left&control-style=volumeButton%3A%20false&duration=1000&autoplay-type=once');
				
				$('.cm-modal-overlay_liveact360').addClass(a);
				scrollTopNow = $(window).scrollTop();
				$('body').addClass(f);
				$( '.container' ).css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				event.preventDefault();
			});

			$('.cm-modal-closeBtn').on('click', function(event){
				
				$('.cm-modal-inner .mod-youtube iframe').attr('src', '');
				
				$('.cm-modal-overlay').removeClass(a);
				$('body').removeClass(f);
				$( '.container' ).css( {
					position: 'static',
				} );
				$(window).scrollTop(scrollTopNow);
				event.preventDefault();
			});

			$('.cm-modal-back').on('click', function(event){

				$('.cm-modal-inner .mod-youtube iframe').attr('src', '');

				$('.cm-modal-overlay').removeClass(a);
				$('body').removeClass(f);
				$( '.container' ).css( {
					position: 'static',
				} );
				$(window).scrollTop(scrollTopNow);
				event.preventDefault();
			});
		},
		loadDelayScript(){
			var _this = this;
			_this.cmmodal();
		}
	};

	$(() => FUNCTIONS.loadDelayScript());
})(window.jQuery, window.FUNCTIONS, window.cssua);